<script>
import { authComputed } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { avatar_gender } from "@/helpers/global.variable";
import VueDropify from "vue-dropify";
import Middleware from "@/helpers/middlewares";

/**
 * up sell Component
 */
export default {
  page: {
    title: "Intent",
  },
  data() {
    return {
      avatarObj: {
        avatarId: "",
        avatar_name: "",
        avatar_image: "",
        fallback_reply: "",
        idle_video_file: "",
        fallback_video_file: "",
        fallback_video_file_status: "0",
        idle_video_file_status: "0",
        avatar_image_status: "0",
        gender: "m",
      },
      image: "",
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
      createError: false,
      errorMessage: "",
      fileUploadLoading: false,
      avatar_gender,
    };
  },

  computed: {
    ...authComputed,
  },
  components: {
    VueDropify,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.currentProps.isEdit) {
        this.avatarObj.avatarId = this.currentProps.updateValue.id;
        this.avatarObj.avatar_name = this.currentProps.updateValue.name;
        this.avatarObj.gender = this.currentProps.updateValue.gender;

        this.avatarObj.avatar_image = this.currentProps.updateValue.photo;
        this.avatarObj.fallback_reply =
          this.currentProps.updateValue.fallback_reply;
        this.avatarObj.idle_video_file =
          this.currentProps.updateValue.idle_video;
        this.avatarObj.fallback_video_file =
          this.currentProps.updateValue.fallback_video;
        this.avatarObj.idle_video_file_status =
          this.currentProps.updateValue.idle_video_file_status;
        this.avatarObj.fallback_video_file_status =
          this.currentProps.updateValue.fallback_video_file_status;
      }
    },

    async handleSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;

      
      let data = {};
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        data = {
          name: this.avatarObj.avatar_name,
          photo: this.avatarObj.avatar_image,
          gender: this.avatarObj.gender,
          idle_video: this.avatarObj.idle_video_file,
          fallback_video: this.avatarObj.fallback_video_file,
          fallback_reply: this.avatarObj.fallback_reply,
        };
        if (!this.currentProps.isEdit) {
          await UserService.addBotAvatar(data)
            .then(async (response) => {
              let tempSlotList;
              await UserService.getSlotList().then((slotListResult) => {
                tempSlotList = slotListResult.slotList;
              });

              await UserService.getIntentsList().then(
                async (intentListResult) => {
                  let hotelIntentList = {};

                  intentListResult.intentList.map((item) => {
                    let tempObj = {};
                    tempObj[item.intent_name] = {
                      name: item.intent_name,
                      id: item.intentId,
                      audio_file: "",
                      video_file: "",
                      text_reply: item.text_reply,
                    };
                    hotelIntentList = { ...hotelIntentList, ...tempObj };
                  });

                  tempSlotList.map((item) => {
                    let tempSlotObj = {};
                    tempSlotObj[item.slot_name] = {
                      name: item.slot_name,
                      id: item.slot_name,
                      audio_file: "",
                      video_file: "",
                      text_reply: "",
                    };
                    hotelIntentList = { ...hotelIntentList, ...tempSlotObj };
                  });

                  hotelIntentList = {
                    ...hotelIntentList,
                    id: response.avatarId,
                  };
                  await UserService.addUpdateBotAvatarIntent(
                    hotelIntentList
                  ).then((intentResponse) => {
                    data.avatarId = response.avatarId;

                    if (this.isSaveAndAddNew) {
                      this.$emit("saveAndAddNew", data);
                    } else {
                      this.$emit("submitted", data);
                    }
                    this.isBtnLoading = false;
                    this.submitted = false;
                  });
                }
              );
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);
              Middleware.notification("Something went wrong !!", "success");

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        } else {
          data.avatarId = this.avatarObj.avatarId;
          UserService.updateIntent(data)
            .then((response) => {
              this.$emit(
                "submitted",
                data,
                this.currentProps.isEdit,
                this.currentProps.isEditable
              );
              this.isBtnLoading = false;
              this.submitted = false;
              Middleware.notification("Successfully updated !!", "success");
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.createError = true;
              errorHandler(error);

              if (typeof error.response.data.non_field_errors == "object") {
                this.errorMessage = error.response.data.non_field_errors;
              } else {
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },

    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.handleSubmit();
    },

    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },

    async uploadFile(event, type) {
      let fileObject = "";
      let fileName = "";

      if (type == "idle_video_file") {
        fileObject = event.target.files[0];
        this.avatarObj.idle_video_file = this.currentProps.hotelId
          ? this.currentProps.hotelId
          : "" + "" + this.randomString(5) + ".mp4";
        fileName = { file_name: this.avatarObj.idle_video_file };
        this.avatarObj.idle_video_file_status = "1";
      } else if (type == "fallback_video_file") {
        fileObject = event.target.files[0];
        this.avatarObj.fallback_video_file = this.currentProps.hotelId
          ? this.currentProps.hotelId
          : "" + "" + this.randomString(5) + ".mp4";
        fileName = { file_name: this.avatarObj.fallback_video_file };

        this.avatarObj.fallback_video_file_status = "1";
      } else {
        fileObject = event[0];
        this.avatarObj.avatar_image = this.currentProps.hotelId
          ? this.currentProps.hotelId
          : "" + "" + this.randomString(5) + ".png";
        fileName = { file_name: this.avatarObj.avatar_image };

        this.avatarObj.avatar_image_status = "1";
      }
      this.fileUploadLoading = true;
      await UserService.mediaFileUrlGenerate(fileName)
        .then((response) => {
          let fileUrl = response.url;
          UserService.mediaFileUpload(fileUrl, fileObject).then((res) => {
            this.fileUploadLoading = false;
            this.submitted = false;
            Middleware.notification(
              "Successfully upload media file !!",
              "success"
            );
          });
        })
        .catch((error) => {
          this.fileUploadLoading = false;
          this.createError = true;
          errorHandler(error);
          Middleware.notification("Something went wrong !!", "danger");
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
    },

    randomString(length) {
      var result = "";
      var characters = "abcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
  validations: {
    avatarObj: {
      avatar_name: {
        required,
      },
      gender: {
        required,
      },
      fallback_reply: {
        required,
      },
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-12">
      <h4>{{ currentProps.isEdit ? "Edit" : "Add New" }} Avatar</h4>
      <hr />
    </div>

    <div class="col-md-6">
      <div class="mb-3">
        <b-form-group class="mb-3" label-for="avatar-input">
          <span slot="label">Name <span class="text-danger">*</span></span>
          <b-form-input
            :disabled="!currentProps.isEditable"
            id="avatar-input"
            type="text"
            placeholder="Avatar name"
            v-model="avatarObj.avatar_name"
            autocomplete="off"
            :class="{
              'is-invalid': submitted && $v.avatarObj.avatar_name.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && $v.avatarObj.avatar_name.$error"
            class="invalid-feedback"
          >
            <span v-if="!$v.avatarObj.avatar_name.required"
              >Avatar name is required.</span
            >
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="col-md-6">
      <div class="mb-3">
        <label for="gender-input">Gender</label>
        <b-form-select
          :disabled="!currentProps.isEditable"
          class="form-select"
          id="gender-input"
          type="text"
          autocomplete="off"
          :options="avatar_gender"
          v-model="avatarObj.gender"
          :class="{
            'is-invalid': submitted && $v.avatarObj.gender.$error,
          }"
        >
        </b-form-select>
        <div
          v-if="submitted && $v.avatarObj.gender.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.avatarObj.gender.required"
            >Avatar name is required.</span
          >
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="mb-3">
        <label class="mb-1 mt-3 fw-medium"
          >Fallback Reply <span class="text-danger">*</span></label
        >
        <textarea
          class="form-control"
          :maxlength="225"
          rows="3"
          placeholder="Fallback reply"
          v-model="avatarObj.fallback_reply"
        ></textarea>
      </div>
    </div>

    <h5 class="mt-4">
      Media

      <div
        class="spinner-border spinner-border-sm"
        role="status"
        v-show="fileUploadLoading"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </h5>
    <div class="col-md-6 mt-2">
      <label for="idle_video_file">Idle Video File</label>
      <input
        type="file"
        class="form-control"
        placeholder="Video File"
        name="idle_video_file"
        @change="uploadFile($event, 'idle_video_file')"
        accept="video/*"
        :src="avatarObj.idle_video_file"
        :disabled="fileUploadLoading"
      />
      <video
        width="320"
        height="240"
        controls
        autoplay
        class="mt-3 w-100"
        v-if="currentProps.isEdit"
      >
        <source
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' +
            avatarObj.idle_video_file
          "
        />
      </video>
    </div>
    <div class="col-md-6 mt-2">
      <label for="video_file"
        >Fallback Video File {{ avatarObj.fallback_video_file }}
      </label>
      <input
        type="file"
        class="form-control"
        placeholder="Fallback video file"
        name="fallback_video_file"
        @change="uploadFile($event, 'fallback_video_file')"
        accept="video/*"
        :src="avatarObj.fallback_video_file"
        :disabled="fileUploadLoading"
      />
      <video
        width="320"
        height="240"
        controls
        autoplay
        class="mt-3 w-100"
        v-if="currentProps.isEdit"
      >
        <source
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' +
            avatarObj.fallback_video_file
          "
        />
      </video>
    </div>
    <div class="col-md-6 mt-3">
      <label for="image">Avatar Image <span class="text-danger">*</span></label>
      <div v-if="!fileUploadLoading">
        <VueDropify
          @upload="uploadFile($event, 'avatar_image')"
          :src="
            'https://vod-lex-files.s3.amazonaws.com/' + avatarObj.avatar_image
          "
          message="Drop image or click here to select"
          class="mb-3"
        />
      </div>
    </div>
    <div class="col-md-12 mt-4">
      <b-button
        class="float-end ms-2"
        variant="outline-primary"
        type="reset"
        @click="cancelSubmit"
        :disabled="fileUploadLoading"
        >Cancel</b-button
      >
      <b-button
        v-if="this.currentProps.isEdit === false"
        class="float-end ms-2"
        variant="outline-primary"
        type="button"
        :class="{ disabled: isSaveAndAddNew === true && isBtnLoading }"
        @click="saveAndAddNew"
        :disabled="fileUploadLoading"
      >
        <i
          v-if="isSaveAndAddNew === true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        Save & Add</b-button
      >
      <b-button
        class="float-end"
        :disabled="fileUploadLoading"
        variant="outline-primary"
        @click="handleSubmit"
        :class="{ disabled: isSaveAndAddNew !== true && isBtnLoading }"
      >
        <i
          v-if="isSaveAndAddNew !== true && isBtnLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
        ></i>
        {{ currentProps.isEdit ? "Update" : "Save" }}
      </b-button>
    </div>
  </div>
</template>
